<nz-layout class="admin-shell">

  <!-- ===== MÁY TÍNH: thanh nhóm trên cùng ===== -->
  <div class="topbar" *ngIf="!isMobile()">
    <div class="brand">
      <img src="assets/images/fox-logo.png" class="brand-logo" alt="Fox Sports" />
    </div>

    <nav class="groupbar" aria-label="Nhóm chức năng">
      <button
        type="button"
        class="gbtn"
        *ngFor="let group of menus"
        [class.is-on]="group.id === activeGroup?.id"
        (click)="selectGroup(group)"
      >
        <i nz-icon [nzType]="group.icon"></i>
        <span>{{ group.title }}</span>
      </button>
    </nav>

    <div class="topbar-right">
      <app-header></app-header>
    </div>
  </div>

  <!-- ===== MÁY TÍNH: hàng tác vụ của nhóm đang mở ===== -->
  <nav class="subtabs" *ngIf="!isMobile() && subTabs.length" aria-label="Tác vụ trong nhóm">
    <button
      type="button"
      class="stab"
      *ngFor="let item of subTabs"
      [class.is-on]="item.id === menuSelected?.id"
      (click)="goItem(item)"
    >
      {{ item.title }}
      <i *ngIf="item.external" nz-icon nzType="export" class="stab-ext"></i>
    </button>
  </nav>

  <!-- ===== ĐIỆN THOẠI: thanh trên cùng ===== -->
  <div class="mobile-topbar" *ngIf="isMobile()">
    <button class="hamburger-btn" (click)="openDrawer()">
      <i nz-icon nzType="menu" style="font-size: 20px;"></i>
    </button>
    <img src="assets/images/fox-logo.png" class="mobile-logo" alt="Fox Sports" />
    <div style="width: 40px;"></div>
  </div>

  <nz-content>
    <router-outlet></router-outlet>
  </nz-content>

</nz-layout>

<!-- ===== ĐIỆN THOẠI: drawer menu ===== -->
<ng-template #drawerTitle>
  <img src="assets/images/fox-logo.png" class="drawer-logo" alt="Fox Sports" />
</ng-template>

<nz-drawer
  [nzVisible]="drawerVisible"
  nzPlacement="left"
  [nzTitle]="drawerTitle"
  nzWidth="280px"
  (nzOnClose)="closeDrawer()"
>
  <ng-container *nzDrawerContent>
    <ul class="mobile-menu-list">
      <ng-container *ngFor="let item of menus">

        <!-- Mục lẻ, không thuộc nhóm nào -->
        <li
          *ngIf="!item.children"
          class="mobile-menu-item"
          [class.active]="item.id === menuSelected?.id"
          (click)="navigateMobile(item)"
        >
          <i nz-icon [nzType]="item.icon" class="menu-icon"></i>
          <span>{{ item.title }}</span>
        </li>

        <!-- Nhóm: hiện tên nhóm rồi tới các tác vụ bên trong -->
        <li *ngIf="item.children" class="mobile-menu-group">
          <div class="mobile-menu-group-title">
            <i nz-icon [nzType]="item.icon" class="menu-icon"></i>
            <span>{{ item.title }}</span>
          </div>
          <ul class="mobile-menu-children">
            <li
              *ngFor="let sub of item.children"
              class="mobile-menu-item mobile-menu-child"
              [class.active]="sub.id === menuSelected?.id"
              (click)="navigateMobile(sub)"
            >
              <i nz-icon [nzType]="sub.icon" class="menu-icon"></i>
              <span>{{ sub.title }}</span>
              <i *ngIf="sub.external" nz-icon nzType="export" style="font-size:11px;margin-left:auto;opacity:0.4;"></i>
            </li>
          </ul>
        </li>

      </ng-container>
    </ul>
  </ng-container>
</nz-drawer>
